import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { DispatchEventClient, DispatchEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

export interface IDispatchApprovalRequest {
  reportId: number | undefined;
  isConfidential: boolean | undefined;
}

function useApproveDispatchEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<DispatchEventReportDTO, ProblemDetails, IDispatchApprovalRequest>({
    mutationKey: [queryKeys.DispatchEvent.Approve],
    mutationFn: ({ reportId, isConfidential }:IDispatchApprovalRequest) => dispatchEventClient.approve(reportId, isConfidential),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useApproveDispatchEvent;
